export const BT_Acquisition_FTTC = {
  GLOBAL_EXTRAS: {
    COMPLETE_WIFI: {
      shortText: "Complete Wifi",
      text:
        "<p class='bold'>A strong Wi-Fi signal in every room of your home, backed by our Complete Wi-Fi Guarantee</p><ul><li>The Wi-Fi Disc talks to your Smart Hub 2 create a seamless, powerful network.</li><li>You should be able to stream HD content anywhere in your home</li><li>A 4+ bedroom house could see Wi-Fi speeds increase by up to 25% with just 1 Wi-Fi Disc</li><li>We guarantee Wi-Fi speeds 10x faster than Sky, as long as your Stay Fast Guarantee is over 30Mb</li></ul>",
      cost: 10
      // altCost: 5
    },
    ALWAYS_ON: {
      shortText: "Always On",
      text:
        "<p class='bold'>Two networks are more reliable than one</p><ul><li>Our clever home Wi-Fi and mobile networks work together to give you a connection that's always on, and always reliable.</li><li>It comes with a <span class='bold'>Hybrid Connector</span> that always talks to your Smart Hub to make sure you're never offline</li></ul>",
      cost: 10
      // altCost: 5
    }
  },
  byDevice: [],
  byPlan: [],
  byCondition: [],
  byPlanAndDevice: []
}
